import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import React, { useState, useMemo, useEffect } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { filterAndSlice } from "../util/selectUtils";

const ReactSelect = ({
  options,
  id,
  field,
  isClearable = false,
  multi = false,
  creatable = false,
  placeholder = "Select...",
  changeHandler,
  onBlur,
  customChangeHandler,
  menuPortalTarget,
  styles
}) => {
  const [inputValue, setInputValue] = useState("");

  const slicedOptions = useMemo(
    () => filterAndSlice(options, inputValue),
    [options, inputValue]
  );

  const findDefault = () => {
    if (Array.isArray(id)) {
      return options.filter((opt) => {
        if (id.includes(opt.value)) {
          return opt;
        }
      });
    }
    if (creatable && id) {
      return createOption(id);
    }
    return options.find((opt) => opt.value === id);
  };

  const onChange = (opts) => {
    if (customChangeHandler) {
      customChangeHandler(opts);
      return;
    }

    const el = document.getElementById(field);
    if (isEmpty(opts)) {
      el.value = opts
      return null;
    }
    if (multi) {
      const array = opts.map((opt) => opt.value);
      el.value = JSON.stringify(array);
    } else {
      el.value = opts.value;
    }
    if (changeHandler) {
      changeHandler(opts)
    }
  };

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        onChange(createOption(inputValue));
        setInputValue("");
    }
  };

  useEffect(() => {
    if (field) {
      const el = document.getElementById(field);
      if (!isEmpty(id)) {
        el.value = multi ? JSON.stringify(id) : id;
      }
    }
  }, []);

  if (creatable) {
    return (
      <CreatableSelect
        isClearable={true}
        onBlur={onBlur}
        onChange={(option) => onChange(option)}
        onInputChange={(value) => setInputValue(value)}
        options={slicedOptions}
        filterOption={() => true} // disable native filter
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        defaultValue={findDefault()}
        menuPortalTarget={menuPortalTarget}
        styles={styles}
      />
    );
  } else {
    return (
      <Select
        id="react-select"
        isClearable
        options={slicedOptions}
        onBlur={onBlur}
        onChange={(option) => onChange(option)}
        onInputChange={(value) => setInputValue(value)}
        filterOption={() => true} // disable native filter
        defaultValue={findDefault()}
        placeholder={placeholder}
        isMulti={multi}
        menuPortalTarget={menuPortalTarget}
        styles={styles}
      />
    );
  }
};
ReactSelect.propTypes = {
  field: PropTypes.string,
};
export default ReactSelect;
